import mAxios from "axios";
import OidcService from "@/core/services/OidcService";

mAxios.defaults.withCredentials = true;

const mAxiosApi = mAxios.create({
  baseURL: process.env.VUE_APP_BACK_URL ? process.env.VUE_APP_BACK_URL : window.location.protocol+"//"+window.location.host+"/sv3",
  withCredentials: true,
});

// Request interceptor: attach Bearer token if OIDC session exists
mAxiosApi.interceptors.request.use(
  async (config) => {
    const token = await OidcService.getAccessToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: handle XSRF tokens and auth errors
mAxiosApi.interceptors.response.use(
  function (response) {
    if (response.headers["x-xsrf-token"]) {
      document.cookie =
        "XSRF-TOKEN=" + response.headers["x-xsrf-token"] + "; path=/";
    }
    return response;
  },
  async function (error) {
    // On 401, attempt silent renew if OIDC is active
    if (error.response && error.response.status === 401) {
      const isOidc = await OidcService.isAuthenticated();
      if (isOidc) {
        try {
          await OidcService.signinSilent();
          // Retry the original request with new token
          const token = await OidcService.getAccessToken();
          if (token && error.config) {
            error.config.headers.Authorization = `Bearer ${token}`;
            return mAxios(error.config);
          }
        } catch {
          // Silent renew failed, redirect to login
        }
      }
    }
    return Promise.reject(error);
  }
);

export default mAxiosApi;
